module.exports = __webpack_public_path__ + "static/media/arrow.66e7e59c.svg";